/** SUB — the one navigation seam between the project log and SubBuilder.
 *
 *  The log is a VIEW of SubBuilder's packages, so "Edit" has to land on the package itself. The
 *  request is stashed before the tab switch because SubBuilder mounts after the event fires. */
const OPEN_KEY = "abs.subbuilder.open";
const BACK_KEY = "abs.ops.open_project";

export const openInSubBuilder = (req) => {
  sessionStorage.setItem(OPEN_KEY, JSON.stringify({ ...req, at: Date.now() }));
  window.dispatchEvent(new CustomEvent("abs:navigate", { detail: { tab: "subbuilder" } }));
};

export const takeSubBuilderRequest = () => {
  const raw = sessionStorage.getItem(OPEN_KEY);
  if (!raw) return null;
  sessionStorage.removeItem(OPEN_KEY);
  try { return JSON.parse(raw); } catch { return null; }
};

export const backToProject = (req) => {
  sessionStorage.setItem(BACK_KEY, JSON.stringify({ tab: "submittals", ...req }));
  window.dispatchEvent(new CustomEvent("abs:navigate", { detail: { tab: "opsprojects" } }));
};

export const takeProjectRequest = () => {
  const raw = sessionStorage.getItem(BACK_KEY);
  if (!raw) return null;
  sessionStorage.removeItem(BACK_KEY);
  try { return JSON.parse(raw); } catch { return null; }
};
